import React from 'react';
import Seo from '../components/Seo';
import ComponentList from '../components/ComponentList';
import Splash from '../components/Splash';

export default ({pageContext, location}) => {
	const {seo = {}, components = []} = pageContext;

	const metaTitle = seo.metaTitle || 'Pasque';
	const openGraphTitle = seo.openGraphTitle || 'Pasque';
	const twitterTitle = seo.twitterTitle || 'Pasque';

	return (
		<React.Fragment>
			<Seo
				metaTitle={metaTitle}
				metaDescription={seo.metaDescription}
				metaKeywords={seo.metaKeywords}
				openGraphTitle={openGraphTitle}
				openGraphDescription={seo.openGraphDescription}
				openGraphImage={seo.openGraphImage}
				twitterTitle={twitterTitle}
				twitterDescription={seo.twitterDescription}
				twitterImage={seo.twitterImage}
				pathname={location.pathname}
			/>
			{/* <ComponentList components={components} /> */}
			<Splash />
		</React.Fragment>
	);
};
